import SectionHeader from "./SectionHeader";

const ranked = [
  { rank: "01", title: "反差黑料人物是谁", heat: "极热", cls: "bg-primary-100 text-primary-800" },
  { rank: "02", title: "事件主角「幕布」身份整理", heat: "高热", cls: "bg-accent-100 text-accent-900" },
  { rank: "03", title: "当事人回应口径逐条对照", heat: "高热", cls: "bg-accent-100 text-accent-900" },
  { rank: "04", title: "账号矩阵关系线能否闭合", heat: "升温", cls: "bg-secondary-100 text-secondary-900" },
  { rank: "05", title: "聊天记录真实性讨论", heat: "升温", cls: "bg-secondary-100 text-secondary-900" },
];

const clusters = [
  {
    group: "人物身份",
    items: ["主角幕布", "前合作方L", "关联号对照相", "账号归属", "人设落差", "谁才是中心"],
  },
  {
    group: "证据线索",
    items: ["聊天记录", "过往发言", "发布时间线", "截图原始性", "交叉核验", "第三方佐证"],
  },
  {
    group: "围观视角",
    items: ["站队之争", "反转预测", "误伤排查", "社区长文", "律师解读", "本页持续更新"],
  },
];

export default function TopicWall() {
  return (
    <section id="topics" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <SectionHeader
          kicker="PART 05 · 话题墙"
          title="关于反差黑料的是谁，大家在看什么"
          desc="把一个宏大问题拆成可跟读的小话题。点开任意一块，都能顺着同一线索继续深挖——当前均为静态标签，可点击定位到本页对应模块。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* 热议榜 */}
          <div className="lg:col-span-5 rounded-xl border border-background-200 bg-background-100/60 p-5 md:p-6">
            <h3 className="text-base md:text-lg font-semibold text-foreground-950 font-heading mb-4 inline-flex items-center gap-2">
              <i className="ri-fire-line text-accent-600 w-5 h-5 flex items-center justify-center" />
              本周期热议榜
            </h3>
            <ol className="space-y-3">
              {ranked.map((r) => (
                <li key={r.rank}>
                  <a
                    href={r.rank === "01" ? "#personas" : r.rank === "03" ? "#doubts" : "#relation"}
                    className="flex items-center gap-3 rounded-lg bg-background-50 border border-background-200 px-3 py-2.5 hover:border-primary-300 transition-colors"
                  >
                    <span className="font-heading text-sm font-semibold text-primary-600 w-6 shrink-0">{r.rank}</span>
                    <span className="flex-1 text-sm font-medium text-foreground-800 whitespace-nowrap overflow-hidden text-ellipsis">
                      {r.title}
                    </span>
                    <span className={`rounded-full px-2 py-0.5 text-[11px] whitespace-nowrap ${r.cls}`}>{r.heat}</span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* 标签分类墙 */}
          <div className="lg:col-span-7 rounded-xl border border-background-200 bg-background-100/60 p-5 md:p-6">
            <h3 className="text-base md:text-lg font-semibold text-foreground-950 font-heading mb-4 inline-flex items-center gap-2">
              <i className="ri-price-tag-3-line text-primary-600 w-5 h-5 flex items-center justify-center" />
              标签分类墙
            </h3>
            <div className="flex flex-col gap-5">
              {clusters.map((c) => (
                <div key={c.group}>
                  <p className="text-xs font-medium text-foreground-500 mb-2">{c.group}</p>
                  <div className="flex flex-wrap gap-2">
                    {c.items.map((t) => (
                      <a
                        key={t}
                        href="#topics"
                        className="inline-flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
                      >
                        <i className="ri-hashtag text-primary-400 w-3.5 h-3.5 flex items-center justify-center" />
                        {t}
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}